import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { Order } from '~src/spacesPlatform/models/sort/Order';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { IOrderClause } from '~src/spacesPlatform/serverApi/types/IOrderClause';

import { OrderKeys } from '../../../spacesPlatform/models/OrderKeys';

interface DatasourceSubspaceSortOptions {
  defaultOrder: IOrderClause[];
  options: OptionsDictionary;
}

export const DatasourceSubspaceConnectionsSortOptions: DatasourceSubspaceSortOptions = {
  defaultOrder: [Order.asc(OrderKeys.connectionTypeDisplayName)],
  options: {
    'type': SortOptions.connectionType
  }
};
